import React, { Component } from 'react';
import { Cell, Grid } from 'react-md';
import { SegmentedControl } from 'segmented-control';
import QuestionSync from '../component/QuestionSync';
import SecureShow from '../component/SecureShow';
import SyncEnable from '../component/SyncEnable';
import '../css/archive.css';
import '../css/Dashboard.css';





export default class PerfGraphs extends Component{

    constructor(props){
        super(props);
        this.state = {
            archiveInProgress:false,
            showSyncEnable:true,
            showSyncUpdate:false
        };
    }

    

    //Event Handlers
    tabOnChange =(clickedValue) =>{
        console.debug("tabOnChange : "+clickedValue);
        if(clickedValue === 'syncEnable'){
            this.setState({showSyncEnable:true,showSyncUpdate:false});
        }
        if(clickedValue === 'syncUpdate'){
            this.setState({showSyncEnable:false,showSyncUpdate:true});
        }

        
    }

    render(){
        return  <SecureShow targetRole={2} >
                    <Grid gutter={1} className="gradeBookPageContainer">
                        <Cell size={12} >
                            <h1 className = "md-text--theme-primary" style = {{textAlign:'center', fontSize: 40}}>
                               Synchronization</h1>
                        </Cell>                        
                        <Cell size={6}>
                            <SegmentedControl
                                name="sync-tabs"
                                style={{color: '#bb0000'}}
                                options={[
                                { label: 'Sync Enable', value: 'syncEnable', default: true },
                                { label: 'Sync Update', value: 'syncUpdate' }
                                ]}
                                setValue={newValue => this.tabOnChange(newValue)}
                            />
                        </Cell>
                        
                        {
                             this.state.showSyncEnable?
                             <Cell size={12} className="gradebook-cell">   
                                <SyncEnable/>
                            </Cell>
                            :
                            undefined
                        }
                        {
                            this.state.showSyncUpdate?
                            <Cell size={12} className="gradebook-cell">   
                               <QuestionSync />
                              
                           </Cell>
                           :
                           undefined
                            
                        }
     
                        
                    </Grid>
                </SecureShow>
    }
}
